<template>
  <div class="work-box">
    <button id="show-modal" @click="showInternModal(index)">
      <img :src="intern(index).WorkImg">
      <h3>{{ intern(index).title }}</h3>
      <ul>
        <li v-for="skill in intern(index).skills">{{ skill }}</li>
      </ul>
      <div v-if="intern(index).isLong" class="period long">
        長期
      </div>
      <div v-else class="period short">
        短期
      </div>
    </button>
    <modal v-if="isShowModal" @close="hideModal"></modal>
  </div>
</template>

<script>
  import Modal from "@/components/modules/Modal";
  import { mapActions, mapGetters } from 'vuex'

  export default {
    props: ['index'],
    components: {
      Modal
    },
    methods: {
      ...mapActions({
        showInternModal: 'Works/showInternModal',
        hideModal: 'Works/hideModal'
      })
    },
    computed: {
      ...mapGetters('Works',{
        'isShowModal': 'getShowModal',
        'intern': 'getIntern',
      })
    }

  }
</script>
<style scoped>
  .work-box{
    display: inline-block;
    vertical-align: middle;
    width: 280px;
    margin: 10px;
    padding: 5px;
    border: solid #2c3e50 2px;
    -webkit-border-radius: 15px;
    -moz-border-radius: 15px;
    border-radius: 5px;
  }
  img{
    width: 210px;
    height: 140px;
    object-fit: cover;
    transition: all 0.3s ease;
  }
  .work-box:hover img{
    filter: blur(4px);
  }
  button{
    /* buttonのデフォルトデザインリセット */
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;
    padding: 0;
    appearance: none;
    width: 100%;
    height: 100%;
    border-radius: 5px;
    cursor: pointer;
  }
  ul{
    padding: 0;
  }
  ul li{
    display: inline-block;
    vertical-align: middle;
    border: solid #2c3e50 1px;
    margin-right: 2px;
    padding: 0.25em;
    background: #beb5fc;
    border-radius: 15px 0px 0px 15px;
    color: white;
  }
  ul li:before{
    display:inline-block;
    /*以下白丸つくる*/
    content:'';
    width:1em;
    height: 1em;
    background: #fff;
    border-radius: 50%;
    margin-right: 8px;
  }
  .period{
    display: inline-block;
    padding: 0 5px;
    border-radius: 5px;
    color: white;
  }
  .period.long{
    border: solid 2px #6aa1fc;
    background-color: #91bcfc;
  }
  .period.short{
    border: solid 2px #fc4a3e;
    background-color: #fc6852;
  }
</style>




// WEBPACK FOOTER //
// src/components/modules/InternBox.vue